/**
 * UTF-8 safe base64 encode for browser code. Round-trips with {@link decodeBase64Utf8}.
 *
 * `btoa` rejects code points > 0xff, so we encode through `TextEncoder` first to
 * preserve multi-byte characters (accents, emoji) across the round trip.
 */
export const encodeBase64Utf8 = (text: string): string => {
  const bytes = new TextEncoder().encode(text);
  // Build the binary string via Array.from + join — avoids the O(n²) `binary += ...` loop
  // pattern. Don't reach for `String.fromCharCode(...bytes)` as the spread form stack-overflows
  // for large payloads (e.g. multi-MB attachments uploaded as base64).
  const binary = Array.from(bytes, (b) => String.fromCharCode(b)).join('');
  return btoa(binary);
};

/** UTF-8 safe base64 decode. Inverse of {@link encodeBase64Utf8}. */
export const decodeBase64Utf8 = (data: string): string => {
  const binary = atob(data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new TextDecoder().decode(bytes);
};
